const IconSettingDials = (): JSX.Element => {
  return (
    <>
      <path
        d="M11 8C9.69375 8 8.58249 8.83485 8.17067 10.0001L0 10V12L8.17102 12.0009C8.58311 13.1656 9.69412 14 11 14C12.3059 14 13.4169 13.1656 13.829 12.0009L16 12V10L13.8293 10.0001C13.4175 8.83485 12.3063 8 11 8ZM11 10C11.5523 10 12 10.4477 12 11C12 11.5128 11.614 11.9355 11.1166 11.9933L11 12C10.4477 12 10 11.5523 10 11C10 10.4872 10.386 10.0645 10.8834 10.0067L11 10ZM5 0C6.30625 0 7.41751 0.83485 7.82933 2.00009L16 2V4L7.82898 4.0009C7.41688 5.16562 6.30588 6 5 6C3.69412 6 2.58311 5.16562 2.17102 4.0009L0 4V2L2.17067 2.00009C2.58249 0.83485 3.69375 0 5 0ZM5 2C4.44772 2 4 2.44772 4 3C4 3.51284 4.38604 3.93551 4.88338 3.99327L5 4C5.55228 4 6 3.55228 6 3C6 2.48716 5.61396 2.06449 5.11662 2.00673L5 2Z"
        fill="currentColor"
      />
    </>
  );
};

export default IconSettingDials;
